import React, { useEffect, useMemo, useState } from "react";
import { ConfigProvider, theme as antdTheme } from "antd";
import Login from "./Page/Auth/Login";
import { Provider } from "react-redux";
import AuthContext from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { aplicarDensidad, leerDensidad } from "./hook/usePreferenciasUI";
import useTheme from "./hook/useTheme";
import { getAntdThemeConfig } from "./theme/themeConfig";
import Admin from "./Layout/Admin";
import store from "./redux/store";
import { GetToken, removeDatosUsuario } from "./utils/storeUsuario";
import "./styles/theme-tokens.css";
// REDISENO-SMARTMEDIC FASE 1: capa de alias del rediseño. DESPUES de
// theme-tokens.css a proposito -- lee sus variables, no las reemplaza.
import "./styles/design-tokens.css";

// THEMES-01: ConfigProvider raíz de Ant Design. Montado por ENCIMA de todo el
// árbol (Login incluido) para que sus portales (Modal/Drawer/Select/Dropdown/
// DatePicker/Tooltip/Table/Pagination) hereden el tema en toda la app.
function ThemedAntdProvider({ children }) {
  const { resolvedTheme } = useTheme();
  const config = useMemo(
    () => getAntdThemeConfig(resolvedTheme, antdTheme),
    [resolvedTheme]
  );
  return <ConfigProvider theme={config}>{children}</ConfigProvider>;
}

export default function Rpp() {
  const [auth, setAuth] = useState(undefined);
  const [ReloadUser, setReloadUser] = useState(false);

  // SISTEMA-DE-DISENO: la densidad de tablas se estampa al arrancar, no cuando
  // el usuario abre Configuración > Apariencia. Si no, elegir "compacta" y
  // recargar devolvía todas las tablas a la altura normal.
  useEffect(() => {
    aplicarDensidad(leerDensidad());
  }, []);

  useEffect(() => {
    const user = GetToken();
    if (user != null) {
      setAuth(user.token);
    } else {
      setAuth(null);
    }
    setReloadUser(false);
  }, [ReloadUser]);

  const login = (user) => {
    setAuth(user);
    setReloadUser(true);
  };

  const logout = () => {
    removeDatosUsuario();
    setAuth(null);
    setReloadUser(!ReloadUser);
    window.location.href = "/";
  };

  const authData = useMemo(() => ({
    auth, login, logout, setReloadUser,
  }), [auth]);

  // RBAC-CUTOVER-09: /api-docs publico (sin /admin, sin login) retirado --
  // mostraba exactamente el mismo ApiDocsViewer que /admin/api-docs, ahora
  // protegido por platform.api_docs.view. Dos superficies equivalentes, una
  // protegida y otra publica, no es una decision de autorizacion valida.
  // Un usuario autenticado con el permiso llega al mismo contenido via
  // /admin/api-docs; sin auth cae al flujo normal de Login.

  // THEMES-01: ThemeProvider + ConfigProvider envuelven SIEMPRE (incluso el
  // estado `auth === undefined`), asi el tema queda aplicado sin flash mientras
  // se resuelve la sesion. El script anti-FOUC de index.html ya estampo el
  // data-theme antes de montar React.
  return (
    <ThemeProvider>
      <ThemedAntdProvider>
        <Provider store={store}>
          <AuthContext.Provider value={authData}>
            {auth === undefined ? null : !auth ? <Login /> : <Admin />}
          </AuthContext.Provider>
        </Provider>
      </ThemedAntdProvider>
    </ThemeProvider>
  );
}
